<template>
  <v-app id="app">

    <!--<div class="closing">-->
      <!--<p>-->
              <!--The Better Living Clinic and Endoscopy Center will be closed as of March 24, 2020 in response to COVID-19,-->
              <!--based on guidance from CDC for non-essential heathcare providers.  If you are sick, please go to the Emergency Room.-->


            <!--</p>-->
      <!--<p>-->
        <!--We are closely monitoring the situation and will re-open as soon it is safe and responsible to do so.-->
        <!--Thank you for your understanding and stay safe.-->
      <!--</p>-->

    <!--</div>-->





<!--    <div class="open">-->
<!--      <p>-->
<!--        The Better Living Clinic and Endoscopy Center has re-opened!-->


<!--      </p>-->
<!--      <p>-->
<!--        As per CDC and State guidelines we are seeing most patients remotely and scheduling in-office visits as needed.-->

<!--      </p>-->

<!--    </div>-->





    <div id="main-background-gradient"></div>

    <!--add 'app' to nav-bar if the navbar should be fixed at top of page-->
    <!--<nav-bar></nav-bar>-->

    <!-- Sizes your content based upon application components -->
    <v-content>
      <router-view></router-view>
    </v-content>


    <!--add 'app' to footer if the navbar should be fixed at top of page-->
    <v-footer color="#2196F3">
      <div class="footer">Copyright 2020 Better Living Endoscopy Center</div>
    </v-footer>
  </v-app>







</template>


<style scoped lang="scss">
  @import 'assets/styles/variables/Variables';


  .closing{
    background: rgba(255, 0, 0, 0.55);
    text-align: center;
    font-size: x-large;
  }


  .open{
    background: rgba(123, 255, 83, 0.55);
    text-align: center;
    font-size: large;
  }


  #app{
    background: none;
  }


  #main-container{
    /*background: none;*/
    padding: 0;
  }


  #main-background-gradient{
    position: fixed;
    height: 100%;
    /*min-height: 1000px;*/
    width: 100%;
    margin: 0;

    //color: $color-white;
    background: $color-app-background;
    z-index: -1;
    /*opacity: 0.5;*/

  }

  .footer{
    /*background: #2196F3;*/
    text-align: center;
    width:100%;
  }


</style>

<script>
   import navBar from '@/components/navBar.vue'

export default {
  name: 'App',

  components: {
     navBar
  },

  data: () => ({
    //
  }),
   created(){

   }
};
</script>
